import gql from 'graphql-tag';

export default gql`
query ($id: String!) {
  getAdvertiser(id: $id) {
    __typename
    id
    name
    costModifier
    postClickLookback
    postViewLookback,
    reports {
      id
      name
    }
  }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Roles/GetQuery.js